export default __webpack_public_path__ + "static/media/cpf-coupon-autolink-example.e05b71fe.png";